import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faFacebook,
  faLinkedin,
  faTwitter,
  faEthereum,
} from "@fortawesome/free-brands-svg-icons";

export default library.add(faFacebook, faLinkedin, faTwitter, faEthereum);
